// copied and edited from packages/ui/src/components/FlavorFinder/components/ResultSuggestionCard/FlavorFinderResultSuggestionCard.tsx
import type { FC } from "react";
import { useEffect, useState } from "react";

import { ResponsiveImage } from "@ui/components/ResponsiveImage";
import { useTranslations } from "@ui/providers/useTranslations";
import classNames from "classnames";

import { RadioButton } from "@jti/core-components";

import styles from "../Results/FlavorFinderResults.module.scss";

type FlavorFinderResultSuggestionCardProps = {
  description: string;
  imgUrl: string;
  onSelectionChange: (value: string) => void;
  useResultsWithDeviceLink: string;
};

export const FlavorFinderResultSuggestionCard: FC<FlavorFinderResultSuggestionCardProps> = ({
  description,
  imgUrl,
  onSelectionChange,
  useResultsWithDeviceLink,
}) => {
  const [gradientBackground, setGradientBackground] = useState("");
  const { __ } = useTranslations();

  useEffect(() => {
    setGradientBackground(`linear-gradient(291deg, #2D2926 1.61%, #3A393B 98.69%)`);
  }, []);

  const [selectedOption, setSelectedOption] = useState<string>(useResultsWithDeviceLink);

  useEffect(() => {
    onSelectionChange(selectedOption);
  }, [selectedOption, onSelectionChange]);

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setSelectedOption(newValue);
    onSelectionChange(newValue);
  };

  return (
    <div className={classNames(styles.result, styles.resultSuggestedDevice)}>
      <div
        className={styles.resultSuggestionCard}
        data-testid="flavor-finder-result-suggesgted-device"
        style={{ background: gradientBackground }}
      >
        <div className={styles.resultCardImage}>
          <ResponsiveImage largeSrc={imgUrl} />
        </div>
        <div className={styles.resultCardText}>
          <p className={styles.resultCardTitle}>{description}</p>
          <div className={classNames(styles.inputs, "dark-theme")}>
            <RadioButton
              id="suggested-device-yes"
              value="yes"
              label={__("flavorfinder.general.yes")}
              name="answerGroup"
              data-testid="suggested-device-yes"
              checked={selectedOption === "yes"}
              onChange={handleOptionChange}
            />
            <RadioButton
              id="suggested-device-no"
              value="no"
              label={__("flavorfinder.general.no")}
              name="answerGroup"
              data-testid="suggested-device-no"
              checked={selectedOption === "no"}
              onChange={handleOptionChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
